module.exports = __webpack_public_path__ + "img/Kids.eba23be2.svg";